module.exports = __webpack_public_path__ + "static/media/delete-doc.276f8d9d.svg";